module.exports = __webpack_public_path__ + "img/n6-bg1.fd0e8419.png";